<template>
  <div class="warp">
    <div class="warp1">
      <div class="top">
        <div class="top_cent">
          <div class="top_p">
            <p class="top_cent_p">
              <i class="el-icon-location"></i>
              <span>天津</span>
              <i class="el-icon-arrow-down icon"></i>
            </p>
            <p>|</p>
            <p style="margin-top:2px;">
              <img src="../../assets/img/top_btn_home.png" alt />
            </p>
            <router-link :to="{path:'/'}" tag="p" style="padding:0;">
              <a href="#" class="aa">商企服首页</a>
            </router-link>
          </div>
          <ul class="top_ul">
            <li>登陆 | 注册</li>
            <router-link :to="{path:'/jiejue'}" tag="li">商会后台</router-link>
            <router-link :to="{path:'/fuwushang'}" tag="li">卖家中心</router-link>
            <router-link :to="{path:'/zhengfu'}" tag="li">政府机构</router-link>
            <li>
              <i class="el-icon-phone"></i>022-8821-9596
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 登录 -->
    <!-- 内容 -->
    <div class="content">
      <img src="../../assets/img/jieju/fws_settled in_banner.png" alt />
    </div>
    <div class="content1_1">
      <div class="content1">
        <div class="content1_one">
          <img src="../../assets/img/jieju/fws_settled in_step03.png" alt />
        </div>
        <div class="content1_two">
          <div class="content1_two_left">
            <p>身份证正面</p>
            <div class="content1_two_left1">
              <img src="../../assets/img/jieju/fws_img_sfz.png" alt />
            </div>
          </div>
          <div class="content1_two_left">
            <p>营业执照正面</p>
            <div class="content1_two_left1">
              <img src="../../assets/img/jieju/fws_img_yyzz.png" alt />
            </div>
          </div>
        </div>
        <div class="content1_three">
          <p @click="tijiao()">
            <a href="#">提交</a>
          </p>
        </div>
        <div class="content1_one">
          <p>上传身份照片示例：</p>
          <img src="../../assets/img/jieju/fws_img_tips01.png" alt />
          <img src="../../assets/img/jieju/fws_img_tips02.png" alt />
          <img src="../../assets/img/jieju/fws_img_tips03.png" alt />
          <img src="../../assets/img/jieju/fws_img_tips04.png" alt />
        </div>
      </div>
    </div>
    <!-- di'bu -->
    <div class="floor">
      <div class="floor_1">
        <img src="../../assets/img/bottom_logo_white.png" alt class="img" />
        <ul>
          <li>
            <a href="#">关于商企服</a>
          </li>
          <li>
            <a href="#">商企服服务平台</a>
          </li>
          <li>
            <a href="#">|</a>
          </li>
          <li>
            <a href="#">联系电话：022-8821-9596</a>
          </li>
          <p>Copyright © 1998 - 2019 newcoc. All Rights Reserved.</p>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getLoginphone, getRegionList } from "@/http/api";
import VueNeditorWrap from "vue-neditor-wrap";
import editor from "@/config/editor";
import config from "@/config/index";
export default {
  components: {
    VueNeditorWrap
  },
  data() {
    return {
      from: {
        ecord: "",
        phone: "",
        address: "",
        introduction: "",
        name: "",
        providers_name: "",
        office_address_province_id: ""
      },
      TIME_COUNT: 60, //验证码倒计时60s
      show: true,
      cang: false,
      count: "",
      upImgUrl: config.api + "/Goods/uploadHeaderImage",
      imgPath: config.apiPath
    };
  },
  methods: {
    // 跳转
    leimu() {
      this.$router.push({ name: "home" });
    },
    getCode(from) {
      if (!/^1[34578]\d{9}$/.test(this.from.phone)) {
        this.cang = !this.cang;
      } else if (/^1[34578]\d{9}$/.test(this.from.phone)) {
        this.cang = false;
        getLoginphone({ phone: this.from.phone }).then(res => {
          console.log(res);
        });
        if (!this.timer) {
          this.count = this.TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= this.TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      }
    },
    handleRemove(file, fileList) {
      this.article.image = "";
    },
    handlePictureCardPreview(file) {
      this.dialogVisible = true;
    },
    handleAvatarSuccess(res, file) {
      console.log(file);
      this.article.image = res.data;
      console.log(res.data);
    },
    handleExceed(files, fileList) {
      this.$message.error("只能上传张图片！");
    },
    tijiao(){
        this.$router.push({
            name:'home'
        })
    }
  },
  created() {}
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}

.warp {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
}

.top {
  width: 100%;
  background: #f5f6fa;
}

.top_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.aa {
  color: #222222;
}

.top_p {
  font-size: 14px;
  color: #222222ff;
  line-height: 40px;
  float: left;
}

.top_p p {
  float: left;
  padding: 0 12px;
}

.top_cent_p {
  color: #007bffff;
}

.icon {
  color: #000;
}

.top_ul {
  width: 550px;
  height: auto;
  display: flex;
  float: right;
}

.top_ul li {
  font-size: 14px;
  line-height: 40px;
  color: #666666;
  margin-left: 39px;
}
.warp1 {
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
  min-width: 1200px;
}

.floor {
  width: 100%;
  height: 139px;
  background: #2d3236;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.img {
  padding: 54px 0;
  float: left;
}

.floor_1 ul {
  width: 480px;
  height: 96px;
  float: right;
  padding: 44px 0;
}

.floor_1 ul li a {
  float: left;
  padding: 0 0 0 33px;
  color: #ffffff;
  font-size: 14px;
}
.floor_1 ul p {
  font-size: 14px;
  font-weight: 400;
  float: right;
  color: #85919aff;
  padding: 20px 0;
}

/* 内容 */

.content {
  width: 100%;
  height: auto;
  background: #000;
}

.content img {
  margin-left: 214px;
}

.content1_1 {
  width: 100%;
  height: auto;
  background: #f4f5f9;
  overflow: hidden;
}

.content1 {
  width: 940px;
  height: auto;
  margin: 20px auto;
  background: #fff;
  overflow: hidden;
}

.content1_one {
  width: 750px;
  height: 49px;
  margin: 30px auto;
}
.content1_one p {
  width: auto;
  text-align: right;
  float: left;
  line-height: 36px;
  margin-right: 38px;
  font-family: Microsoft YaHei;
  font-weight: 600;
  color: rgba(27, 27, 32, 1);
  line-height: 32px;
  margin-left: 40px;
  margin-bottom: 80px;
}

.content1_three {
  width: 750px;
  height: 104px;
  margin: 30px auto;
  border-bottom: 1px solid rgba(228, 228, 228, 1);
}

.content1_three p {
  width: 260px;
  height: 44px;
  background: rgba(0, 123, 255, 1);
  border-radius: 4px;
  text-align: center;
  margin: 0 auto;
}

.content1_three p a {
  line-height: 44px;
  color: #fff;
}

.content1_two {
  width: 750px;
  height: auto;
  margin: 50px auto;
  overflow: hidden;
}

.content1_two_left {
  width: 300px;
  height: auto;
  margin-left: 50px;
  float: left;
}

.content1_two_left p {
  font-family: Microsoft YaHei;
  font-weight: 600;
  color: rgba(27, 27, 32, 1);
  line-height: 32px;
  margin-bottom: 30px;
}

.content1_two_left1 {
  width: 300px;
  height: 196px;
  border: 1px solid #e4e4e4;
}

.content1_two_left1 img {
  margin: 14px 14px;
}

.upload {
  width: 272px;
  height: 168px;
}
</style>



// WEBPACK FOOTER //
// src/view/jiejue/Settledtwo.vue